import React, { useState } from 'react';
import { Route, Routes , useLocation } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Login from '../pages/auth/login/Login';
import Header from '../components/Header/Header';
import Register from '../pages/auth/login/Register';
import Footer from '../components/Header/Footer';
import Dashboard from '../pages/Dashboard/Dashboard';
import Products from '../pages/Dashboard/products/Products';
import AddProducts from '../pages/Dashboard/products/AddProducts';
import Pricing from '../pages/Dashboard/Price/Pricing';
import Styles from '../pages/Dashboard/Styles/Styles';
import AspectRatio from '../pages/Dashboard/AspectRatio/AspectRatio';
import Upload from '../pages/Dashboard/Upload/Upload';


const Routing = () => {
    return (
        <div>
            <Routes>
                <Route path="/login" element={<Login/>}/>
                <Route path="/" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>
                <Route path="/dashboard" element={<Dashboard/>}>
                    <Route path="/dashboard/product" element={<Products/>} />
                    <Route path="/dashboard/add-products" element={<AddProducts/>} />
                    <Route path="/dashboard/pricing" element={<Pricing/>} />
                    <Route path="/dashboard/styles" element={<Styles/>} />
                    <Route path="/dashboard/aspect-ratio" element={<AspectRatio/>} />
                    <Route path="/dashboard/upload" element={<Upload/>} />
                </Route>
            </Routes>
            
        </div>
    );
};

export default Routing;